import { useState } from "react";

function DashboardDocuments() {
    const [activeModule, setActiveModule] = useState("module1");

    const modules = [
        { id: "module1", label: "Module 1" },
        { id: "module2", label: "Module 2" },
        { id: "module3", label: "Module 3" },
        { id: "module4", label: "Module 4" },
        { id: "module5", label: "Module 5" },
        { id: "module6", label: "Module 6" },
    ];

    return (

           <>
            <div className="module-tabs ">
                {modules.map((m) => (
                    <button
                        key={m.id}
                        className={`module-tab ${
                            activeModule === m.id
                                ? "active"
                                : ""
                        }`}
                        onClick={() => setActiveModule(m.id)}
                    >
                        {m.label}
                    </button>
                ))}
            </div>

            <div className="bg-[#E2F2FF] rounded-xl p-6 shadow-md border border-blue-200">
                <div className="max-w-7xl mx-auto">
                    {/* Module Content Wrapper */}
                    <div className="download-list">
                        {/* Module 1 */}
                        {activeModule === "module1" && (
                            <div className="module-content lg:pl-16 lg:pr-16">
                                <DownloadItem filename="Presentation3-Implementing User-Centered Design.pptx" />
                                <DownloadItem filename="Guide1-Effective Team Collaboration Strategies.docx" />
                                <DownloadItem filename="Article5-The Future of Artificial Intelligence in Design.html" />
                            </div>
                        )}

                        {/* Module 2 */}
                        {activeModule === "module2" && (
                            <div className="module-content lg:pl-16 lg:pr-16">
                                <DownloadItem filename="Presentation4-Advanced Reading Techniques.pptx" />
                                <DownloadItem filename="Guide2-Critical Thinking in Reading.docx" />
                            </div>
                        )}

                        {/* Module 3 */}
                        {activeModule === "module3" && (
                            <div className="module-content lg:pl-16 lg:pr-16">
                                <DownloadItem filename="Presentation5-Advanced Data Analysis.pptx" />
                                <DownloadItem filename="Article6-Understanding Context.html" />
                            </div>
                        )}

                        {/* Module 4 */}
                        {activeModule === "module4" && (
                            <div className="module-content lg:pl-16 lg:pr-16">
                                <DownloadItem filename="Presentation6-Themes and Motifs.pptx" />
                            </div>
                        )}

                        {/* Module 5 */}
                        {activeModule === "module5" && (
                            <div className="module-content lg:pl-16 lg:pr-16">
                                <DownloadItem filename="Guide3-Analyzing Characters.docx" />
                            </div>
                        )}

                        {/* Module 6 */}
                        {activeModule === "module6" && (
                            <div className="module-content lg:pl-16 lg:pr-16">
                                <DownloadItem filename="Article7-Advanced Reading Strategies.html" />
                            </div>
                        )}
                    </div>
                </div>
            </div>
           </>
    );
}

// 🔽 Reusable Download Item Component
function DownloadItem({ filename }) {
    return (
        <div className="download-item">
            <div className="download-info">
                <div className="file-icon ">
                    <svg
                        className="w-6 h-6"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                        ></path>
                    </svg>
                </div>
                <div className="file-name">{filename}</div>
            </div>

            <button className="download-btn">
                <span>Download</span>
                <svg
                    className="w-4 h-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                    ></path>
                </svg>
            </button>
        </div>
    );
}

export default DashboardDocuments;
